@if (customerForm) {
  <form [formGroup]="customerForm" class="page-root-wrap">
    <mat-card class="expand-half">
      <mat-card-header>
        <mat-card-title>{{ "label.address" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{ "form.label.companyName" | transloco }}</mat-label>
          <input matInput type="text" formControlName="name" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{ "form.label.street" | transloco }}</mat-label>
          <input matInput type="text" formControlName="street" />
        </mat-form-field>

        <div class="row-gap">
          <mat-form-field hideRequiredMarker="true" class="horizontal-constraint">
            <mat-label>{{ "form.label.zipCode" | transloco }}</mat-label>
            <input matInput type="text" formControlName="zipCode" />
          </mat-form-field>

          <mat-form-field hideRequiredMarker="true" class="flex">
            <mat-label>{{ "form.label.city" | transloco }}</mat-label>
            <input matInput type="text" formControlName="city" />
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="expand-half">
      <mat-card-header>
        <mat-card-title>{{ "label.contact" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content class="column-stretch">
        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{ "form.label.phone" | transloco }}</mat-label>
          <input matInput type="text" formControlName="phone" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{ "form.label.mobile" | transloco }}</mat-label>
          <input matInput type="text" formControlName="mobile" />
        </mat-form-field>

        <mat-form-field hideRequiredMarker="true">
          <mat-label>{{ "form.label.email" | transloco }}</mat-label>
          <input matInput type="text" formControlName="email" />
        </mat-form-field>

        @if (useMailing) {
          <mat-form-field>
            <mat-label>{{ "form.label.sender_mail" | transloco }}</mat-label>
            <mat-select [(value)]="selectedSender" (selectionChange)="changeSender($event)">
              @for (dto of emailSenders; track $index) {
                <mat-option [value]="dto"> {{ dto.email }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ "form.label.sender_name" | transloco }}</mat-label>
            <input matInput type="text" formControlName="senderName" />
          </mat-form-field>
        }
      </mat-card-content>
    </mat-card>
  </form>
}
